// extracted by mini-css-extract-plugin
export default {"link":"LinkButton_link__f-vE5","link_disabled":"LinkButton_link_disabled__lTZyj","link_secondary":"LinkButton_link_secondary__z+sLf"};